import styled from '@emotion/styled';
import { colors, spacing, breakpoints } from '../../../../utils/styleguide';
import Typography from '../../text/Typography';
import { hexColors } from './OurApproachLayout';
import { ReactNode } from 'react';

const Card = styled.div<{ index: number }>`
  display: flex;
  position: relative;
  padding: ${spacing[6]}px ${spacing[5]}px;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  box-sizing: border-box;
  gap: ${spacing[1]}px;
  background-color: ${({ index }) => hexColors[index]};

  ${breakpoints.desktop} {
    flex: 1 0 50%;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[5]}px;
  width: auto;
  align-self: stretch;
`;

export default function StepCard({ children, index }: { children: ReactNode; index: number }) {
  return (
    <Card index={index} className={`step-card step-card-${index}`}>
      <CardHeader>
        <Typography variant="overline" color={colors.blackSecondary}>{`Step 0${
          index + 1
        }`}</Typography>
        <hr
          style={{
            flex: 1,
            border: `0.5px solid ${colors.blackSecondary}`,
          }}
        />
      </CardHeader>
      {children}
    </Card>
  );
}
